import { createTheme } from '@mui/material'
import { primaryTheme } from './theme1'
import { secondaryTheme } from './theme2'

const themes = {
  light: createTheme(primaryTheme),
  dark: createTheme(secondaryTheme)
}

export default themes
